(function() {
    angular
        .module("app")
        .factory("imagesService", imagesService)

    function imagesService() {

        const _service = {}

        _service.getBeaconsImage = (device) => {

            if (device.hasOwnProperty("speed_limit_display")) {

                if (device.speed_limit_display.speed > 0 && device.speed_limit_display.beacons === true) {

                    return device.speed_limit_display.base_image_url + "BeaconsOn.gif"

                }

                return device.speed_limit_display.base_image_url + "BeaconsOff.gif"

            } else if (device.hasOwnProperty("wvsl2")) {

                if (device.wvsl2.speed_display.speed > 0 && device.wvsl2.speed_display.beacons === true) {

                    return device.wvsl2.speed_display.base_image_url + "BeaconsOn.gif"

                }

                return device.wvsl2.speed_display.base_image_url + "BeaconsOff.gif"
            }

            return undefined

        }

        _service.getDisplayImage = (device) => {

            if (device.hasOwnProperty("speed_limit_display")) {

                if (device.speed_limit_display.errors && (device.speed_limit_display.errors.speed || device.speed_limit_display.errors.options)) {

                    if (device.speed_limit_display.errors.speed) {

                        return device.speed_limit_display.base_image_url + "ErrorSpeed.png"

                    } else {

                        return device.speed_limit_display.base_image_url + "ErrorOptions.png"

                    }

                } else if (device.speed_limit_display.speed > 0) {

                    let style  = "_BW"

                    if (device.speed_limit_display.white_on_black) {
                        style = "_WB"
                    }

                    return device.speed_limit_display.base_image_url + device.speed_limit_display.speed + style + ".png"

                }

                return device.speed_limit_display.base_image_url + "Blank.png"

            }

            if (device.hasOwnProperty("image_url")) {

                return device.image_url

            }

            return undefined

        }

        return _service

    }
})()
